import React from "react";

import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";

import CookingMethodForm from "./CookingMethodForm";
import RecipeFormTab from "./RecipeFormTab";
import { useRecipe } from "../store/RecipeStore";

enum Steps {
  RecipeDetails,
  CookingInstructions,
}

const TabContents = () => {
  const recipe = useRecipe();

  const renderTabContents = () => {
    switch (recipe.step.activeStep) {
      case Steps.RecipeDetails:
        return <RecipeFormTab />;
      case Steps.CookingInstructions:
        return <CookingMethodForm />;
      default:
        return <RecipeFormTab />;
    }
  };

  return <Box>{renderTabContents()}</Box>;
};

export default observer(TabContents);
